// Routeur minimal fondé sur l'API History (aucune dépendance).
class Router {
  path = $state(location.pathname);
  query = $state(new URLSearchParams(location.search));

  constructor() {
    addEventListener('popstate', () => this.sync());
    document.addEventListener('click', (e) => {
      const a = (e.target as HTMLElement).closest('a');
      if (!a || a.target || a.hasAttribute('download') || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      const url = new URL(a.href, location.href);
      if (url.origin !== location.origin || url.pathname.startsWith('/v1/') || url.pathname.endsWith('.csv')) return;
      e.preventDefault();
      this.go(url.pathname + url.search + url.hash);
    });
  }

  sync() {
    this.path = location.pathname;
    this.query = new URLSearchParams(location.search);
  }

  go(to: string, replace = false) {
    if (replace) history.replaceState(null, '', to);
    else history.pushState(null, '', to);
    this.sync();
    scrollTo(0, 0);
    // Accessibilité : le focus revient au contenu principal après un changement de page.
    queueMicrotask(() => document.getElementById('contenu')?.focus());
  }

  match(pattern: string): Record<string, string> | null {
    const p = pattern.split('/');
    const s = this.path.replace(/\/$/, '').split('/');
    if (p.length !== s.length && !pattern.endsWith('*')) return null;
    const out: Record<string, string> = {};
    for (let i = 0; i < p.length; i++) {
      if (p[i] === '*') return out;
      if (p[i]!.startsWith(':')) out[p[i]!.slice(1)] = decodeURIComponent(s[i] ?? '');
      else if (p[i] !== s[i]) return null;
    }
    return out;
  }
}

export const router = new Router();
